import { api } from '@/lib/api'
import type { SetupChecklistItemKey, SetupChecklistItemStatus } from '@tenfour/domain'

/**
 * The sidebar setup checklist.
 *
 * Account scope comes from the auth claim server-side, so none of these calls
 * take an account id — passing one would only invite the client to lie about it.
 */

export interface SetupChecklistRow {
  key: SetupChecklistItemKey
  title: string
  detail: string
  href: string
  actionLabel: string
  dismissible: boolean
  status: SetupChecklistItemStatus
  completedAt: string | null
  dismissedAt: string | null
}

export interface SetupChecklistResponse {
  items: SetupChecklistRow[]
  /** Items still wanting work. Dismissed does not count. */
  remaining: number
  /** Every item done or dismissed — the rail stops showing the card. */
  complete: boolean
}

export function getSetupChecklist(): Promise<SetupChecklistResponse> {
  return api<SetupChecklistResponse>('/setup-checklist')
}

export function dismissSetupChecklistItem(key: string): Promise<SetupChecklistResponse> {
  return api<SetupChecklistResponse>(`/setup-checklist/${encodeURIComponent(key)}/dismiss`, {
    method: 'POST',
  })
}

export function restoreSetupChecklistItem(key: string): Promise<SetupChecklistResponse> {
  return api<SetupChecklistResponse>(`/setup-checklist/${encodeURIComponent(key)}/restore`, {
    method: 'POST',
  })
}
